import { Drawer, DrawerOverlay, useDisclosure } from '@chakra-ui/react'
import { Button } from '@nextui-org/react'
import { FC } from 'react'
import settingGear from '../../assets/icons/settingGear.png'
import { TankInfoConfiguration } from './TankInfoConfiguration'

export type TankInfoTitleProps = {
  tankId: string
  tankName: string | null
}

export const TankInfoTitle: FC<TankInfoTitleProps> = ({ tankId, tankName }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <div className="flex flex-col mb-[20px] p-[10px]">
      <div className="flex flex-col gap-2">
        {/* Mobile: Tank Information on first line */}
        <h1 className="text-tdplindigo font-bold text-[2rem] md:hidden">Tank Information</h1>

        {/* Desktop and Mobile second line */}
        <div className="flex flex-row md:justify-between items-center gap-2">
          {/* Desktop: Tank Information + Tank Name */}
          <div className="hidden md:flex flex-row items-center gap-2">
            <h1 className="text-tdplindigo font-bold text-[2rem]">Tank Information</h1>
            {tankName ? <h1 className="text-tdpllightgrey text-[2rem] mx-2">{' / '}</h1> : null}
            {tankName ? (
              <h1 className="text-tdplindigo font-bold text-[2rem]">{tankName}</h1>
            ) : null}
          </div>

          {/* Mobile: Tank Name + Button */}
          {tankName ? (
            <h1 className="text-tdplindigo font-bold text-[2rem] basis-[80%] md:hidden">
              {tankName}
            </h1>
          ) : null}
          <div className="flex items-center justify-center align-middle basis-[20%] md:hidden ml-auto">
            {/* <Button className="bg-white" isIconOnly onClick={onOpen}>
              <img src={settingGear} alt="" />
            </Button> */}
          </div>

          {/* Desktop: Settings Button */}
          <div className="hidden md:flex items-center justify-center align-middle">
            {/* <Button className="bg-white" isIconOnly onClick={onOpen}>
              <img src={settingGear} alt="" />
            </Button> */}
          </div>
        </div>
      </div>

      <p className="text-[0.875rem] text-tdplindigo">
        In "Tank Information", you can monitor the detailed data collected for each tank.
      </p>

      <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="sm">
        <DrawerOverlay />
        <TankInfoConfiguration tankId={tankId} tankName={tankName} onClose={onClose} />
      </Drawer>
    </div>
  )
}

export default TankInfoTitle
